import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { Message, MessageBox } from 'element-ui';
import router from '@/router';
import api from '@/api';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    loginByAccountAndPassword: function loginByAccountAndPassword(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dispatch, _ref2, _ref2$account, account, _ref2$password, password, res, payloadData, tokenUser;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$account = _ref2.account, account = _ref2$account === void 0 ? '' : _ref2$account, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
              // 清除数据
              localStorage.clear();

              // 关闭所有Tab（切换用户的时候Tab会保留之前信息）
              _context.next = 5;
              return dispatch('d2admin/page/closeAll', true, {
                root: true
              });
            case 5:
              _context.next = 7;
              return api.loginByAccountAndPassword({
                account: account,
                password: password,
                terminal: 'WEB',
                readRoles: true
              });
            case 7:
              res = _context.sent;
              if (!(res.data.category !== 'admin')) {
                _context.next = 11;
                break;
              }
              Message.error('无权限');
              return _context.abrupt("return");
            case 11:
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.token.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              // 设置用户昵称
              localStorage.setItem('userNickname', tokenUser.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户类别
              localStorage.setItem('userCategory', tokenUser.category || '');
              // 设置用户状态
              localStorage.setItem('userState', tokenUser.state || '');
              // 设置用户级别
              localStorage.setItem('userLevel', tokenUser.level || '');
              // 设置用户Token
              localStorage.setItem('token', res.data.token);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', new Date().getTime());
              // 设置用户菜单
              localStorage.setItem('menu', JSON.stringify(res.data.userMenus));

              // 向 vuex 中增加用户信息
              _context.next = 26;
              return dispatch('d2admin/user/set', {
                name: res.data.nickname
              }, {
                root: true
              });
            case 26:
              _context.next = 28;
              return dispatch('load');
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    } // Token 刷新
    ,
    refreshToken: function refreshToken() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var token, lastRefreshTokenTime, nowTime, refreshToken, tokenExpTime, res, payloadData, tokenUser;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 获取Token
              token = localStorage.getItem('token') || ''; // 如果没有Token则去登录
              if (token) {
                _context2.next = 5;
                break;
              }
              router.replace('/login');
              _context2.next = 38;
              break;
            case 5:
              // 获取上次刷新时间
              lastRefreshTokenTime = localStorage.getItem('lastRefreshTokenTime') || 0;
              if (!(lastRefreshTokenTime <= 0)) {
                _context2.next = 10;
                break;
              }
              // 如果没有最后一次刷新时间则去登录
              router.replace('/login');
              _context2.next = 38;
              break;
            case 10:
              // 获取当前时间
              nowTime = new Date().getTime(); // 判断当前是否超过1小时未刷新去登录
              if (!(nowTime - lastRefreshTokenTime > 1 * 60 * 60 * 1000)) {
                _context2.next = 15;
                break;
              }
              router.replace('/login');
              _context2.next = 38;
              break;
            case 15:
              // 获取刷新Token
              refreshToken = localStorage.getItem('refreshToken') || ''; // 判断是否存在刷新Token
              if (refreshToken) {
                _context2.next = 20;
                break;
              }
              router.replace('/login');
              _context2.next = 38;
              break;
            case 20:
              // 获取Token失效时间
              tokenExpTime = localStorage.getItem('tokenExp') * 1000 || 0; // 判断Token有效期 是否将要到期 (当前时间 - Token有效期 < 10分钟)
              if (!(tokenExpTime - nowTime < 10 * 60 * 1000)) {
                _context2.next = 38;
                break;
              }
              _context2.next = 24;
              return api.refreshToken({
                refreshToken: refreshToken
              });
            case 24:
              res = _context2.sent;
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              // 设置用户昵称
              localStorage.setItem('userNickname', tokenUser.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户类别
              localStorage.setItem('userCategory', tokenUser.category || '');
              // 设置用户状态
              localStorage.setItem('userState', tokenUser.state || '');
              // 设置用户级别
              localStorage.setItem('userLevel', tokenUser.level || '');
              // 设置用户Token
              localStorage.setItem('token', res.data);
              // 设置TokenUser
              localStorage.setItem('tokenUser', tokenUser);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', nowTime);
            case 38:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    ,
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$confirm = _ref4.confirm,
        confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;
      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                // 清除数据
                localStorage.clear();

                // 清空 vuex 用户信息
                _context3.next = 3;
                return dispatch('d2admin/user/set', {}, {
                  root: true
                });
              case 3:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    }
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    ,
    load: function load(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var dispatch;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              dispatch = _ref5.dispatch;
              _context4.next = 3;
              return dispatch('d2admin/user/load', null, {
                root: true
              });
            case 3:
              _context4.next = 5;
              return dispatch('d2admin/theme/load', null, {
                root: true
              });
            case 5:
              _context4.next = 7;
              return dispatch('d2admin/transition/load', null, {
                root: true
              });
            case 7:
              _context4.next = 9;
              return dispatch('d2admin/page/openedLoad', null, {
                root: true
              });
            case 9:
              _context4.next = 11;
              return dispatch('d2admin/menu/asideLoad', null, {
                root: true
              });
            case 11:
              _context4.next = 13;
              return dispatch('d2admin/size/load', null, {
                root: true
              });
            case 13:
              _context4.next = 15;
              return dispatch('d2admin/color/load', null, {
                root: true
              });
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};